import React from 'react'
import { TbArrowBigLeftFilled } from "react-icons/tb"
import "./CreatePost.scss"
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Button from 'react-bootstrap/Button';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { useHistory } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './Firebase/Firebase';
import { BsPlusSquareDotted } from "react-icons/bs"
import { Watch } from 'react-loader-spinner';

const modules = {
    toolbar: [[{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }, { align: "left" }],
    ["link", "image", "video"],

    ],

}



function CreatePost() {
    useEffect(() => {
        return () => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } })
        };
    }, []);
    const [Title, setTitle] = useState('');
    const [Content, setContent] = useState('');

    const [photo, setPhoto] = useState(null); // Store the selected photo
    const [PhotoUrl, setPhotoUrl] = useState('');
    const [label, setLabel] = useState('');
    const [labels, setLabels] = useState([]); // Store available labels fetched from Firestore
    const history = useHistory();
    const [uploading, setUploading] = useState(false); // To track if an image is uploading

    useEffect(() => {
        // Fetch all labels from Firestore
        const fetchLabels = async () => {
            const labelsRef = firebase.firestore().collection('Labels');
            const snapshot = await labelsRef.get();
            const labelsData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setLabels(labelsData);
        };

        fetchLabels();
    }, []);

    const handleGoBack = () => {
        history.goBack(); // This will go back to the previous page
    };
    const handleQuillChange = (value) => {
        setContent(value);
    };

    const currentUser = firebase.auth().currentUser;

    const handleImageChange = async (e) => {
        if (e.target.files[0]) {
            const selectedImage = e.target.files[0];
            // Define the minimum and maximum allowed dimensions
            const minWidth = 240;
            const maxWidth = 2016;
            const minHeight = 224;
            const maxHeight = 2160;

            const img = new Image();
            img.src = URL.createObjectURL(selectedImage);

            img.onload = () => {
                const imageWidth = img.width;
                const imageHeight = img.height;

                if (
                    imageWidth < minWidth ||
                    imageWidth > maxWidth ||
                    imageHeight < minHeight ||
                    imageHeight > maxHeight
                ) {
                    // Image dimensions are outside the allowed range
                    alert(
                        `Please select an image with dimensions between ${minWidth}x${minHeight} and ${maxWidth}x${maxHeight} pixels.`
                    );
                    // Reset the file input to clear the selection
                    e.target.value = '';
                } else {
                    setPhoto(selectedImage);
                    setPhotoUrl(URL.createObjectURL(selectedImage));
                }
            };
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Get the currently authenticated user
        const user = firebase.auth().currentUser;

        if (user && photo) {
            setUploading(true);
            const imageRef = ref(storage, `/users/images/${currentUser.displayName}/` + photo.name);

            try {
                const snapshot = await uploadBytes(imageRef, photo);
                const url = await getDownloadURL(snapshot.ref);

                setPhotoUrl(url);
                console.log('File uploaded successfully!');
                setUploading(false);

                // Create a new post in Firestore
                const postRef = firebase.firestore().collection('Posts').doc();
                await postRef.set({
                    postId: postRef.id,
                    uid: user.uid,
                    Title,
                    PhotoUrl: url,
                    label,
                    name: user.displayName,
                    Content,
                    Time: firebase.firestore.FieldValue.serverTimestamp(),
                });
                // Add a ratings subcollection for the post
                const ratingsCollectionRef = postRef.collection('ratings');

                // Add an initial rating document for this post (optional)
                // This could be useful if you want to store some initial rating value or metadata
                const initialRatingData = {
                    rating: 1,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                };

                // Create a new document in the ratings subcollection with the initialRatingData
                await ratingsCollectionRef.add(initialRatingData);

                // Clear the form
                setTitle('');
                setPhoto(null);
                setContent('');
                setLabel('');


                // Redirect to the blog post page or wherever you want to navigate after creating the post
                history.push('/blog'); // Replace '/posts' with your desired URL
            } catch (error) {
                console.error('Error uploading file:', error);
                setUploading(false);
            }
        }
    };
    


    return (
        <div>
            <div className="navigating">
                <div className="arrow">
                    <TbArrowBigLeftFilled onClick={handleGoBack} />
                </div>
                <div className="BrandCreate">
                    <h4>mete & design</h4>
                </div>
            </div>

            <section className='FormSect'>
                <Container className='FormSectCont' fluid>
                    <h2>Create Blog post</h2>
                    <div className="forming">
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col className="fussion">



                                    <Form.Group className='formJy'>
                                        <div className="imager">

                                            <div className="uploading">
                                                {uploading ? (
                                                    <div className="uploading">
                                                        <Watch color="#121212" width="40px" ariaLabel="watch-loading" className="watchSpn" radius="48" data-testid="loader" />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {PhotoUrl ? (
                                                            <label htmlFor="imageInput" className="plusup">
                                                                <img src={PhotoUrl} alt="Selected" />
                                                            </label>
                                                        ) : (
                                                            <>
                                                                <div className="uploading">
                                                                    {/* BsPlusSquareDotted icon will only be shown when no image is selected */}
                                                                    <label htmlFor="imageInput" className="plusup">
                                                                        <BsPlusSquareDotted className='doty' />
                                                                    </label>
                                                                </div>
                                                                <input id="imageInput" type="file" accept="image/*" className="picUploader visually-hidden" onChange={handleImageChange} />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                        </div>
                                        <div className='inpu'>
                                            <Form.Control type='file' accept='image/*' className='picUploader' onChange={handleImageChange}></Form.Control>
                                        </div>

                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formGroupLabel">
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Label"
                                            className="mb-3 bg-transparent text-dark"
                                        >
                                            <Form.Select aria-label="Default select example" required as='select'
                                                value={label} onChange={(e) => setLabel(e.target.value)}
                                            >
                                                <option value="">Select Label</option>
                                                {labels.map((labelOption) => (
                                                    <option key={labelOption.id} value={labelOption.name}>{labelOption.name}</option>
                                                ))}

                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formGroupHeading">
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Heading"
                                            className="mb-3 bg-transparent text-dark"
                                        >
                                            <Form.Control type="text" placeholder='Heading' required
                                                value={Title}
                                                onChange={(e) => setTitle(e.target.value)} />
                                        </FloatingLabel>
                                        <Form.Text id="passwordHelpBlock" muted className='text-start'>
                                            <strong>Tip: </strong> Your Heading Must be short and straightforward.
                                        </Form.Text>
                                    </Form.Group>

                                </Col>
                                <Col className="fission">
                                    <Form.Group className="mb-3 hidden-preview" controlId="formGroupEditor">
                                        <ReactQuill
                                            theme='snow'
                                            className='textArea2'
                                            required
                                            value={Content}
                                            onChange={handleQuillChange}
                                            modules={modules}

                                        />

                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>


                                    <Button type="submit" className='PostBtn'>Post</Button>
                                    <div className="padIt">
                                        <Form.Text className='tips'>
                                            <p><strong>Tips: 1.</strong>  Select a label from the list of labels that best describes your post. </p>
                                            <p> <strong>2.</strong> You can add photos and videos in your post from the text editor.
                                            </p>
                                        </Form.Text>
                                    </div>

                                    <Container>
                                        <div className="preview">
                                            <div className="preview-heading">
                                                <h2>Preview</h2>
                                            </div>
                                            <div className="allConty">
                                                <div className="hedr">
                                                    <div className="imh">
                                                        <img src={PhotoUrl} alt="" className='theImg' />
                                                    </div>
                                                    <p className='preview-label'>{label}</p>
                                                    <p className='author-name'>@{currentUser.displayName} <span>- Post Date</span></p>
                                                    <p className='preview-header'>{Title}</p>
                                                </div>
                                                <div name="texty" className='preview-text' disabled
                                                    
                                                    dangerouslySetInnerHTML={{ __html: document.querySelector('.hidden-preview .ql-editor')?.innerHTML }}
                                                ></div>
                                            </div>
                                        </div>
                                    </Container>
                                </Col>



                            </Row>
                        </Form>
                    </div>

                </Container>
            </section>
        </div>
    )
}

export default CreatePost
